import {combineReducers} from 'redux';
import undoable, {excludeAction} from 'redux-undo';

import appReducer from './app';
import busyReducer from './busy';
import nodeListReducer from './nodeList';
import * as NodeListActions from '~app/actions/nodeList';
import driveReducer from './drive';

export default combineReducers({
  app: appReducer,
  busy: busyReducer,
  nodeList: undoable(nodeListReducer, { filter: excludeAction([NodeListActions.SELECT_NODE, NodeListActions.CLEAR_NODES]) }),
  drive: driveReducer,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js